import React, { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { ConfigProvider, Select } from 'antd';

const ThemeSelect = forwardRef((props, _ref) => {
  const {
    name,
    control,
    errors,
    rules = {},
    label = '',
    placeholder = '',
    options = [],
    className = '',
    labelClassName = '',
    disabled = false,
    ...rest
  } = props;

  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            colorTextPlaceholder: '#BABABA',
          },
        },
      }}
    >
      <>
        <Controller
          control={control}
          name={name}
          rules={rules}
          render={({ field }) => (
            <>
              <label
                className={`${label ? 'd-block' : 'd-none'} theme-label ${labelClassName} `}
                htmlFor={name}
              >
                {label}
              </label>
              <Select
                {...rest}
                className={`theme-select ${className}`}
                popupClassName="theme-select-popup"
                placeholder={placeholder}
                disabled={disabled}
                value={field.value ?? null}
                onChange={field.onChange}
                popupMatchSelectWidth={false}
                options={options}
              />
            </>
          )}
        />
        {errors[name] && <span className="text-error">{errors[name].message}</span>}
      </>
    </ConfigProvider>
  );
});

export default ThemeSelect;
